import apiService from "./apiServices";

export const updateCustomerDetailsService = async (formData, token) => {
    try {

      const response = await apiService('/client-customers/update', 'PUT', formData, null, token);
      return response;
      } catch (error) {
        throw (error?.message || 'Updating task is failed. Please try again.');
      }
  }

export const getCustomerDetailsById = async (id,token) => {
    try {
      const response = await apiService(`/client-customers/get/${id}`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw error;
    }
  }

    export const getPolicyListingServices = async (id,token) => {
    try {
      const response = await apiService(`/policy/list/client-customer/${id}`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw (error?.message || 'Customer policy list service is failed. Please try again.');
    }
  }